export enum UserActionsEnum {
    GET_PHOTO = 'getPhoto',
    CALL_MS_GRAPH = 'callMsGraph',
    LOGIN = 'start-login-process',
    LOGOUT = 'main-logout',
    TOKEN_REFRESH_TIMER = 'apiTokenTimer',
}
